import React from 'react';
import Select from 'react-select';

import { StatsFilters } from '../../../../../domain/statsFilters';

type QuarterPickerProps = {
    quarterFilters: NonNullable<StatsFilters['quarter']>;
    onChange: (newQuarterFilters: NonNullable<StatsFilters['quarter']>) => void;
    startYear: number;
}

export const QuarterPicker = ({ quarterFilters, onChange, startYear }: QuarterPickerProps) => {
    const handleQuarterChange = (newQuarter: number) => {
        onChange({
            ...quarterFilters,
            quarter: newQuarter,
        });
    };

    const handleYearChange = (newYear: number) => {
        onChange({
            ...quarterFilters,
            year: newYear,
        });
    };

    const currentYear = new Date().getFullYear();
    const yearsCount = currentYear - startYear + 1;
    const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

    const quarterOptions = [
        { value: 1, label: 'I kwartał (styczeń-marzec)' },
        { value: 2, label: 'II kwartał (kwiecień-czerwiec)' },
        { value: 3, label: 'III kwartał (lipiec-wrzesień)' },
        { value: 4, label: 'IV kwartał (październik-grudzień)' }
    ];

    const yearOptions = years.map(year => ({
        value: year,
        label: year.toString()
    }));

    const selectedQuarter = quarterOptions.find(option => option.value === quarterFilters.quarter);
    const selectedYear = yearOptions.find(option => option.value === quarterFilters.year);

    return (
        <div className="d-flex flex-row">
            <div className="me-2" style={{ minWidth: '150px' }}>
                <Select
                    value={selectedQuarter}
                    onChange={(value) => handleQuarterChange(value?.value as number)} // because this Select is not clearable it's never going to be an undefined
                    options={quarterOptions}
                    placeholder="Wybierz kwartał"
                    classNamePrefix="react-select"
                />
            </div>
            <div style={{ minWidth: '100px' }}>
                <Select
                    value={selectedYear}
                    onChange={(value) => handleYearChange(value?.value as number)} // because this Select is not clearable it's never going to be an undefined
                    options={yearOptions}
                    placeholder="Wybierz rok"
                    classNamePrefix="react-select"
                />
            </div>
        </div>
    );
};